import { css } from '@emotion/react';
import { Modal, Type } from '@robinhood/design';
import { NeutralColorToken } from '@robinhood/design';

import Button from 'src/components/creditApplication/Button';

const ExperianWebsiteUrl = 'https://www.experian.com/fraud/center.html';

interface PropsIface {
  onDismiss: () => void;
}

const HelpModal = ({ onDismiss }: PropsIface) => {
  return (
    <Modal width='wide' overrideModalStyles={root} onClose={onDismiss}>
      <div css={textContainer}>
        <Type.Display size='S'>Help with fraud alerts</Type.Display>
        <Type.Text size='M'>
          If you don’t know your fraud alert phone number, or the line is out of service, please update or remove your
          alert on the Experian website.
        </Type.Text>
      </div>
      <div css={buttonContainer}>
        <Button
          label='Visit Experian website'
          icon='LinkOut16'
          width='full'
          type='anchor'
          href={ExperianWebsiteUrl}
          target='_blank noopener noreferrer'
        />
        <Button
          label='Dismiss'
          width='full'
          type='button'
          onClick={onDismiss}
          foregroundColor={NeutralColorToken.Fg1}
        />
      </div>
    </Modal>
  );
};

const root = css`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 24px;
`;

const textContainer = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: center;
`;

const buttonContainer = css`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export default HelpModal;
